import OrderListStockPage from './order-list-stock';

export default OrderListStockPage;